import { ShieldX } from 'lucide-react';

export function AccessDenied() {
  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center p-4">
      {/* Background gradient */}
      <div className="fixed inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800/30 via-[#020617] to-[#020617]" />

      <div className="w-full max-w-md text-center space-y-6">
        <div className="bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-10 space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center">
              <ShieldX className="w-8 h-8 text-red-400" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl font-bold text-slate-100">
            Access Required
          </h1>

          {/* Message */}
          <p className="text-slate-400 leading-relaxed">
            This tool is available through Advisor Nexus. Please open it from your dashboard.
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-slate-600">
          Powered by Trained Advisor
        </p>
      </div>
    </div>
  );
}
